import React, { Component, useEffect, useMemo, useState } from "react";
import "./intemediate-sauda-landing.styles.scss";

import { ReactComponent as IntermediateImage } from "../../assets/intermediate.svg";
import IntermediateScreen from "../intermediate-screen/intermediate-screen.page";
import ApprovalScreen from "../approval-screen/approval-screen.page";
import { canUserAccess } from "../../utils/utils";
import { FeatureCodes } from "../../constants/data-constants";
import {
  selectAuthData,
  selectUserData,
} from "../../redux/user/user.selectors";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Dispatch } from "react";

import { setViewAuctionPage } from "../../redux/common/common.actions";
import {
  selectSelectedBranch,
  selectSelectedCrop,
  selectViewAuctionPage,
} from "../../redux/common/common.selectors";

import { Tabs, message } from "antd";
import {
  getBagTypeDetails,
  getConditionCodes,
} from "../../services/auction-services";

const { TabPane } = Tabs;

const IntemediateSaudaLanding: React.FC = (props: any) => {
  const {
    setViewAuctionPage,
    userData,
    selectedCropId,
    selectedBranch,
    authData,
  } = props;
  const [bagType, setBagType] = useState([]);
  const [conditionCodes, setConditionCodesData] = useState<any>();
  useEffect(() => {
    if (
      canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER) ||
      canUserAccess(userData, FeatureCodes.IM_SCREEN_CHECKER)
    ) {
      setViewAuctionPage("40");
      sessionStorage.setItem("interPage", "40");
    }
  }, []);
  useMemo(async () => {
    const bagTypeResponse = await getBagTypeDetails();
    if (bagTypeResponse.data.status) {
      setBagType(
        bagTypeResponse.data.data.reduce((prevState, currState) => {
          prevState.push({
            id: currState.parameter_data_value,
            val: currState.parameter_display_value,
          });
          return prevState;
        }, [])
      );
    }
  }, [authData.access_token]);

  useMemo(async () => {
    try {
      const response = await getConditionCodes({
        branch_id: selectedBranch,
        crop_id: selectedCropId,
      });
      if (response.data.status) {
        var item = response.data.data;
        if (item && item.length < 5) {
          for (let i = item.length; i < 5; i++) {
            item.push({
              condition_name: "",
              condition_type: "",
              condition_value: null,
              service_vendor_code: null,
            });
          }
        }
        setConditionCodesData(item);
      } else {
        message.error("Something went wrong :(", 1);
        setConditionCodesData([]);
      }
    } catch (error) {
      message.error("Something went wrong :(", 1);
      console.log(error);
    }
  }, [authData.access_token, selectedBranch, selectedCropId]);

  return (
    <div className="intemediate-sauda-landing">
      <Tabs
        defaultActiveKey={"40"}
        onChange={(activeKey) => {
          setViewAuctionPage(activeKey);
          sessionStorage.setItem("interPage", activeKey);
        }}
      >
        {/* {canUserAccess(userData, FeatureCodes.IM_SCREEN_MAKER) && */}
        {bagType.length && (
          <TabPane tab={"Submit PO"} key="40">
            <IntermediateScreen
              conditionCodes={conditionCodes}
              bagTypeData={bagType}
              {...props}
            />
          </TabPane>
        )}
        {/* {canUserAccess(userData, FeatureCodes.IM_SCREEN_CHECKER) &&
          bagType.length && (
            <TabPane
              tab={
                <span className="tabname-container">
                  {" "}
                  <ApprovalImage className="tab-img" />{" "}
                  <div className="tab-name">Approve PO</div>
                </span>
              }
              key="41"
            >
              <IntermediateApproveScreen
                conditionCodes={conditionCodes}
                bagType={bagType}
                {...props}
              />
            </TabPane>
          )} */}
      </Tabs>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectedKey: selectViewAuctionPage,
  userData: selectUserData,
  selectedCropId: selectSelectedCrop,
  selectedBranch: selectSelectedBranch,
  authData: selectAuthData,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    setViewAuctionPage: (activeKey: string) =>
      dispatch(setViewAuctionPage(activeKey)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IntemediateSaudaLanding);
